module.exports = __webpack_public_path__ + "img/14.4e2b83ca.jpg";